import type { PlayerCharacter } from "../types/entity.js";
import { abilityModifier } from "../types/entity.js";
import { rollD20 } from "../combat/dice.js";

/**
 * I17 — pure force-open resolver.
 *
 * Per-character STR check vs `lock_dc + 5`. One attempt per PC per
 * container (the caller tracks the attempted set in `WorldStore` and
 * passes `alreadyAttempted` here). No tool consumption, no noise
 * broadcast (spec: v1 has no noise system).
 */

export const FORCE_OPEN_DC_BONUS = 5;

export type ForceOpenOutcome = "already_attempted" | "success" | "failure";

export interface ForceOpenInput {
  readonly actor: PlayerCharacter;
  readonly lockDc: number;
  readonly alreadyAttempted: boolean;
}

export interface ForceOpenResult {
  readonly outcome: ForceOpenOutcome;
  readonly roll: number;
  readonly bonus: number;
  readonly total: number;
  readonly dc: number;
}

export function attemptForceOpen(input: ForceOpenInput): ForceOpenResult {
  const dc = input.lockDc + FORCE_OPEN_DC_BONUS;
  if (input.alreadyAttempted) {
    return { outcome: "already_attempted", roll: 0, bonus: 0, total: 0, dc };
  }
  const bonus = abilityModifier(input.actor.abilities.STR);
  const roll = rollD20();
  const total = roll + bonus;
  return {
    outcome: total >= dc ? "success" : "failure",
    roll,
    bonus,
    total,
    dc,
  };
}
